module.exports = __webpack_public_path__ + "blueground-logo.png?41eb45d34813465ed0270be688863cfe";